export const DEFAULT_RECORD_TYPE = '012b0000000DoENAA0';

export const SMART_TVS = ['Samsung', 'LG', 'Philips', 'Anders'];

export const DEVICES = [
	'PC/Laptop',
	'Android Phone',
	'Android Tablet',
	'iPhone',
	'iPad',
	'Smart TV',
	'Ziggo box',
	'Playstation',
	'Chromecast',
	'Apple TV',
	'Provider box',
	'Nog niet bekend',
	'Amazon Fire TV Stick',
];

export const REASONS = [
	{
		name: 'Aanmelden of inloggen',
		values: [
			{
				category: 'Inloggen',
				specification: 'Overige problemen inloggen',
				displayLabel: 'Inloggen lukt niet',
			},
			{
				category: 'Account',
				specification: 'Account gegevens wijzigen (incl. e-mailadres)',
				displayLabel: 'E-mailadres wijzigen',
			},
			{
				category: 'Inloggen',
				specification: 'Wachtwoord wijzigen',
				displayLabel: 'Wachtwoord wijzigen',
			},
			{
				category: 'Betalingen',
				specification: 'Activatie procedure',
				displayLabel: 'Abonnement activeren',
			},
		],
	},
	{
		name: 'Ik wil iets kijken',
		values: [
			{
				category: 'Afspeelproblemen',
				specification: 'Video start niet',
				displayLabel: 'Afspelen lukt niet',
			},
			{
				category: 'Afspeelproblemen',
				specification: 'Livestreams & Live TV',
				displayLabel: 'Livestream',
			},
			{
				category: 'Content',
				specification: 'Geen rechten meer',
				displayLabel: 'Titel is niet (meer) te vinden',
			},
			{
				category: 'Content',
				specification: 'Contentverzoekjes',
				displayLabel: 'Vragen of verzoeken over het aanbod',
			},
		],
	},
	{
		name: 'Ondertiteling',
		values: [
			{
				category: 'Content',
				specification: 'Ondertiteling',
				displayLabel: 'Ondertiteling ontbreekt',
			},
			{
				category: 'Content',
				specification: 'Ondertiteling',
				displayLabel: 'Ondertiteling bevat een fout',
			},
		],
	},
	{
		name: 'Betalingen',
		values: [
			{
				category: 'Betalingen',
				specification: 'Rekeningnummer wijzigen',
				displayLabel: 'Rekeningnummer wijzigen',
			},
			{
				category: 'Betalingen',
				specification: 'Abonnement gestopt/hervatten',
				displayLabel: 'Vragen over facturen',
			},
		],
	},
	{
		name: 'Opzeggen',
		values: [
			{
				category: 'Opzeggen',
				specification: 'Informatie over hoe op te zeggen',
				displayLabel: 'Ik wil mijn abonnement opzeggen',
			},
			{
				category: 'Opzeggen',
				specification: 'Opzeggen namens iemand anders',
				displayLabel: 'Ik wil het abonnement namens iemand anders opzeggen',
			},
		],
	},
	{
		name: 'Anders',
	},
];
